import React, { useState, useRef } from "react";
import {
  HStack,
  Icon,
  Text,
  useDisclosure,
  Modal,
  ModalContent,
  ModalOverlay,
  ModalHeader,
  ModalBody,
  ModalFooter,
  SimpleGrid,
  VStack,
  Input,
  Button,
  useToast,
  Spinner,
  Select,
} from "@chakra-ui/react";
import { MdOutlineAddLocationAlt } from "react-icons/md";
import GoogleMapReact from "google-map-react";
import axios from "../../axios";
import Cookies from "js-cookie";

const AddLocation = ({ onAdd }) => {
  const [username, setUsername] = useState("");
  const [houseList, setHouseList] = useState([]);
  const [houseId, setHouseId] = useState("");
  const [description, setDescription] = useState("");
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [modalZoom, setModalZoom] = useState(13);

  const token = Cookies.get("accessToken");
  const toast = useToast();
  const id = "add-location-toast";
  const { isOpen, onOpen, onClose } = useDisclosure();

  const mapRef = useRef(null);
  const mapsRef = useRef(null);
  const markerRef = useRef(null);

  // Утасны дугаараар байшингийн жагсаалт авах
  const handleUsernameChange = (value) => {
    setUsername(value);
    if (value.length === 8) {
      axios
        .get("admin/device_houses", {
          params: { username: value },
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => setHouseList(res.data.data || []))
        .catch((err) =>
          toast({
            id,
            status: "error",
            description: err.response?.data?.message || "Алдаа гарлаа!",
            duration: 2000,
            isClosable: true,
          })
        );
    } else {
      setHouseList([]);
      setHouseId("");
    }
  };

  const handleSelectHouse = (e) => setHouseId(e.target.value);

  // Газрын зураг дээр дарахад координат авах, marker үүсгэх
  const handleMapClick = ({ lat, lng }) => {
    if (!mapRef.current || !mapsRef.current) return;

    if (markerRef.current) {
      markerRef.current.setMap(null);
      markerRef.current = null;
    }

    markerRef.current = new mapsRef.current.Marker({
      position: { lat, lng },
      map: mapRef.current,
      icon: {
        path: mapsRef.current.SymbolPath.CIRCLE,
        scale: 8,
        fillColor: "#45A735",
        fillOpacity: 0.8,
        strokeWeight: 2,
        strokeColor: "#FFF",
      },
    });
    setLatitude(lat.toString());
    setLongitude(lng.toString());
  };

  const handleApiLoaded = ({ map, maps }) => {
    mapRef.current = map;
    mapsRef.current = maps;
  };

  const submitHandler = () => {
    if (
      username.length === 8 &&
      houseId &&
      description &&
      latitude &&
      longitude
    ) {
      setIsSubmitting(true);
      axios
        .post(
          "/v2/user_location/",
          { username, houseId, description, latitude, longitude },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then(() => {
          toast({
            id,
            status: "success",
            description: "Амжилттай!",
            duration: 2000,
            isClosable: true,
          });
          onClose();
          // Reset
          setUsername("");
          setHouseList([]);
          setHouseId("");
          setDescription("");
          setLatitude("");
          setLongitude("");
          if (markerRef.current) {
            markerRef.current.setMap(null);
            markerRef.current = null;
          }
          onAdd();
        })
        .catch(() =>
          toast({
            id,
            status: "error",
            description: "Алдаа гарлаа!",
            duration: 2000,
            isClosable: true,
          })
        )
        .finally(() => setIsSubmitting(false));
    }
  };

  return (
    <>
      <HStack
        w="full"
        h={12}
        bg="#45A735"
        rounded="md"
        shadow="md"
        align="center"
        justify="center"
        cursor="pointer"
        onClick={onOpen}
        _hover={{ shadow: "lg" }}
      >
        <Icon as={MdOutlineAddLocationAlt} w={5} h={5} color="#fff" />
        <Text color="#fff" fontSize={15} fontWeight="normal">
          Хаяг нэмэх
        </Text>
      </HStack>

      <Modal
        isCentered
        size="3xl"
        isOpen={isOpen}
        onClose={onClose}
        closeOnOverlayClick={false}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Хэрэглэгчийн байршил нэмэх</ModalHeader>
          <ModalBody>
            <VStack spacing={4} w="full">
              <SimpleGrid columns={[1, 2]} gap={4} w="full">
                <VStack align={"flex-start"} justify={"flex-start"} spacing={0}>
                  <Text fontSize={14} fontWeight={"medium"} color={"#000"}>
                    Утасны дугаар
                  </Text>
                  <Input
                    placeholder="-"
                    value={username}
                    onChange={(e) => handleUsernameChange(e.target.value)}
                    maxLength={8}
                    w="full"
                    bg="#fff"
                    fontSize={15}
                    fontWeight="normal"
                    color="#000"
                    borderWidth={1}
                    borderColor="#E0E0E0"
                    _hover={{
                      borderColor: "#45A735",
                      borderWidth: 1,
                    }}
                    _focus={{
                      borderColor: "#45A735",
                      borderWidth: 1,
                    }}
                  />
                </VStack>
                <VStack align={"flex-start"} justify={"flex-start"} spacing={0}>
                  <Text fontSize={14} fontWeight={"medium"} color={"#000"}>
                    Байшин
                  </Text>
                  <Select
                    isDisabled={
                      username.length > 7 && houseList.length > 0 ? false : true
                    }
                    placeholder="- Байшин сонго -"
                    value={houseId}
                    onChange={handleSelectHouse}
                    w="full"
                    bg="#fff"
                    fontSize={15}
                    color="#000"
                    borderWidth={1}
                    borderColor="#E0E0E0"
                    _hover={{
                      borderColor: "#45A735",
                      borderWidth: 1,
                    }}
                    _focus={{
                      borderColor: "#45A735",
                      borderWidth: 1,
                    }}
                  >
                    {houseList.map((h) => (
                      <option key={h._id} value={h._id}>
                        {h.name}
                      </option>
                    ))}
                  </Select>
                </VStack>
                <VStack align={"flex-start"} justify={"flex-start"} spacing={0}>
                  <Text fontSize={14} fontWeight={"medium"} color={"#000"}>
                    Дэлгэрэнгүй хаяг
                  </Text>
                  <Input
                    placeholder="-"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    w="full"
                    bg="#fff"
                    fontSize={15}
                    fontWeight="normal"
                    color="#000"
                    borderWidth={1}
                    borderColor="#E0E0E0"
                    _hover={{
                      borderColor: "#45A735",
                      borderWidth: 1,
                    }}
                    _focus={{
                      borderColor: "#45A735",
                      borderWidth: 1,
                    }}
                  />
                </VStack>
                <VStack align={"flex-start"} justify={"flex-start"} spacing={0}>
                  <Text fontSize={14} fontWeight={"medium"} color={"#000"}>
                    Өргөрөг
                  </Text>
                  <Input
                    placeholder="-"
                    type="number"
                    value={latitude}
                    onChange={(e) => setLatitude(e.target.value)}
                    w="full"
                    bg="#fff"
                    fontSize={15}
                    fontWeight="normal"
                    color="#000"
                    borderWidth={1}
                    borderColor="#E0E0E0"
                    _hover={{
                      borderColor: "#45A735",
                      borderWidth: 1,
                    }}
                    _focus={{
                      borderColor: "#45A735",
                      borderWidth: 1,
                    }}
                  />
                </VStack>
                <VStack align={"flex-start"} justify={"flex-start"} spacing={0}>
                  <Text fontSize={14} fontWeight={"medium"} color={"#000"}>
                    Уртраг
                  </Text>
                  <Input
                    placeholder="-"
                    type="number"
                    value={longitude}
                    onChange={(e) => setLongitude(e.target.value)}
                    w="full"
                    bg="#fff"
                    fontSize={15}
                    fontWeight="normal"
                    color="#000"
                    borderWidth={1}
                    borderColor="#E0E0E0"
                    _hover={{
                      borderColor: "#45A735",
                      borderWidth: 1,
                    }}
                    _focus={{
                      borderColor: "#45A735",
                      borderWidth: 1,
                    }}
                  />
                </VStack>
              </SimpleGrid>

              <VStack
                w="full"
                h="40vh"
                bg="#fff"
                rounded="md"
                shadow="md"
                p={2}
              >
                <GoogleMapReact
                  bootstrapURLKeys={{ key: "YOUR_GOOGLE_MAPS_API_KEY" }}
                  defaultCenter={{
                    lat: 47.91948034963807,
                    lng: 106.91772834219846,
                  }}
                  zoom={modalZoom}
                  onChange={({ zoom }) => setModalZoom(zoom)}
                  yesIWantToUseGoogleMapApiInternals
                  onGoogleApiLoaded={handleApiLoaded}
                  onClick={handleMapClick}
                />
              </VStack>
            </VStack>
          </ModalBody>
          <ModalFooter>
            <Button
              colorScheme="gray"
              mr={3}
              px={"8"}
              onClick={onClose}
              _focus={{ outline: "none" }}
            >
              Болих
            </Button>
            <Button
              colorScheme="green"
              px={"8"}
              _focus={{
                outline: "none",
              }}
              onClick={submitHandler}
              isDisabled={
                isSubmitting ||
                !username ||
                !houseId ||
                !description ||
                !latitude ||
                !longitude
              }
            >
              {isSubmitting ? <Spinner size="sm" mr={2} /> : null}
              Хадгалах
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default AddLocation;
